import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgModule } from '@angular/core';

@NgModule({
	exports: [
		MatDialogModule,
		MatSnackBarModule,
		MatToolbarModule
	]
})
export class AngularMaterialModule { }
